import { useEffect, useRef, useState } from 'react'

export const useTempBoolean = (value: boolean, timeout = 1000, lock = false) => {
  const workValue = value || lock
  const timeoutRef = useRef<number | undefined>()
  const [tempValue, setTempValue] = useState(workValue)

  useEffect(() => {
    if (workValue && !lock) {
      timeoutRef.current = window.setTimeout(() => {
        setTempValue(false)
      }, timeout)
    }
    setTempValue(workValue)
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [workValue, lock, timeout])

  return tempValue
}
